// NPM Imports
import React, { useContext } from 'react'
// Quote Context
import { useQuoteContext } from '../../hooks/useQuoteContext'
// Component Imports
import InternalToolbar from '../rows/toolbar/InternalToolbar'
import Banner from '../ui-helper-elements/Banner'
// JS Imports
// Asset Imports

export default function ToolbarSection({
   pricebookID,
   setPricebookIDCallback,
   productPerformanceEECount,
   setProductPerformanceEECount,
   productTestAccount,
   setProductTestAccount,
}) {
   const state = useQuoteContext()

   if (state.user_view != 'External') {
      return (
         <div className='sticky-top'>
            <Banner></Banner>
            <InternalToolbar
               pricebookId={pricebookID}
               setPricebookIDCallback={setPricebookIDCallback}
               productPerformanceEECount={productPerformanceEECount}
               setProductPerformanceEECount={setProductPerformanceEECount}
               productTestAccount={productTestAccount}
               setProductTestAccount={setProductTestAccount}
            />
         </div>
      )
   }
   return null
}
